import React, { ReactNode } from "react";
import { Box, Typography, SxProps, Theme, useTheme } from "@mui/material";
import { modalWrapperStyles, innerWrapperStyles, textStyle } from "./styles";

interface BlockModalWrapperProps {
  lable: string;
  children: ReactNode;
  isColumn?: boolean;
  sx?: SxProps<Theme>;
  md?: number;
}

export const BlockModalWrapper: React.FC<BlockModalWrapperProps> = ({
  lable,
  children,
  isColumn = false,
  md,
}) => {
  const theme = useTheme();
  return (
    <Box sx={modalWrapperStyles(theme, md)}>
      <Box sx={innerWrapperStyles(isColumn)}>
        <Typography sx={textStyle}>{lable}</Typography>
        {children}
      </Box>
    </Box>
  );
};
